export enum ExplainAppAccess {
  EXPLAIN_FRONT = 1,
  EXPLAIN_CSM = 2
}
